export const environment = {
	production: true,
	apiUrl: '/api',
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	signalRHub: '/SIGEFHub'
};
